import React, { useEffect, useState } from 'react'

import { AnnouncementBanner } from './AnnouncementBanner'

const getMetaCommitHash = (htmlText) => {
  const match = htmlText.match(/<meta name="app-commit-hash" content="([^"]+)"/)
  return match ? match[1] : null
}

const currentAppVersion = process.env.COMMIT_HASH

const NewVersionBanner = () => {
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false)

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const result = await fetch('/', { cache: 'no-store' })
        if (result.ok) {
          const html = await result.text()
          const latestVersion = getMetaCommitHash(html)
          if (latestVersion && latestVersion !== currentAppVersion) {
            setIsNewVersionAvailable(true)
          }
        }
      } catch (error) {
        console.error('Error fetching latest version:', error)
      }
    }, 300000) // 5 minutes

    return () => clearInterval(interval)
  }, [])

  if (!isNewVersionAvailable) {
    return null
  }

  return (
    <AnnouncementBanner
      dataTestId="new-version-banner"
      actionLabel="Refresh Now"
      onAction={() => window.location.reload()}
    >
      A new version of Balto is available.
    </AnnouncementBanner>
  )
}

export default NewVersionBanner
